import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { HLockUrl } from './HLockUrl';

export interface HLockDto {
  username: string | null;
  ts: string | null;
}

const postHLock = (data: { path: string[] }) =>
  apiClient.post(HLockUrl.ACQUIRE, data).then((response) => response.data);

export const useAcquireHLockMutation = createApiMutationHook(
  ['hlock', 'acquire'],
  postHLock,
  {
    throwOnError: (error) => error.status !== 423,
  },
);
